var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNaver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#57B04B",
    d: "M0 1.073h8.318s7.556 11.416 7.78 11.723c.226.306.254 0 .254 0-.348-1.768-.726-2.562-.726-5.385V1.073h8.286v21.145h-8.286S8.225 11.412 8.001 11.113c-.223-.298-.252 0-.252 0 .285 1.46.537 1.703.537 4.235v6.87H0V1.073z"
  })));
}

export default SvgNaver;